<template>
  <div>
    <breadcrumbs />
    <div
      class="columns is-12 is-centered"
    >
      <router-view
        :key="$route.fullPath"
        v-if="detailPageOpen"
        v-on:closeDetail="detailReady = false"
        class="column is-12"
        :contents="contractorArray"
        :searchTerm="searchInput"
      />
    </div>
    <div
      v-if="!$route.query.Id"
    >
      <div 
        class="search-bar-contractor"
         v-if="ready"
      >
        <div
          class="columns"
        >
          <div
            class="column is-12 is-centered"
          >
            <SearchBox
              v-model="searchInput"
              @searchclear="searchInput = '', clearFilters()"
              :placeholder="placeholder"
              :handleSearchFormSubmit="getContractorPermits"
            >
            </SearchBox>
          </div>
        </div>
      </div>
      <div
        v-show="status === 'loading'"
        class="columns is-centered"
      >
        <i class="fas fa-spinner fa-spin fa-3x" />
      </div>

      <v-client-table
        v-if="ready && !detailReady && !emptyResponse && this.status === 'results'"
        id="contractor"
        class="full-screen-active results-table contractor-permit-lookup column is-12"
        :data="filterData"
        :columns="['PERMITNUMBER','PERMITTYPE','STATUS','ISSUEDATE','CONTRACTORNAME']"
        :options="this.options"
        @row-click="openDetail($event.row.PERMITNUMBER)"
      >
        <div 
          class="columns"
          id="filters"
          slot="beforeTable"
        >
          <div
            class="column is-4 unset-margin"
          >
            <dropdown
              class="results-filter"
              label="Permit type: "
              v-model="filterTypes.permitTypes"
              :key="`type-${key}`"
              :placeholder="''"
              :inner-label="false"
              :options="$store.state.contractorPermitLookup.permitTypes"
              @change="setFilter($event, 'permitTypes' )"
            />
          </div>  
          <div
            class="column is-5 unset-margin"
          >
            <dropdown
              class="results-filter"
              label="Status: "
              v-model="filterTypes.permitStatus"
              :key="`status-${key}`"
              :placeholder="''"
              :inner-label="false"
              :options="$store.state.contractorPermitLookup.permitStatus"
              @change="setFilter($event, 'permitStatus')"
            />
          </div>  
          <div 
            class="column is-3"
            v-if="filterTypes.permitTypes || filterTypes.permitStatus || filterTypes.contractorNames"
          > 
            <a 
              class="clear-filters has-text-weight-semibold"
              @click="clearFilters()"
            >
              <i class="fas fa-redo"></i> Reset all filters
            </a>
          </div>
        </div> 

        <template
          slot="ISSUEDATE"
          slot-scope="{row}"
        > 
          {{ dateFormat(row.ISSUEDATE) }} 
        </template>

      </v-client-table>
      <div class="columns is-centered">
        <div 
          v-if="ready && status === 'search' && !emptyResponse"
          class="search-bar-content column is-9 "
        >
          <h3 class="is-size-3">
            Enter a contractor or company name, or permit number to look up the status of a permit.
          </h3>
          <br>
          <div class="columns is-centered">
            <p class="column is-11">
              <b> Note: Actions made in the last 24 hours may not be reflected in results. </b>
            </p>
          </div>
        </div>
        <div 
          class="search-error search-bar-content"
          v-if="status === 'error'"
        >
          <p><span class="red">!</span> No results found for {{ searchInput }}. </p>
        </div> 
      </div>
    </div>

  </div>
</template>
<script>
import SearchBox from '@/components/SearchBox';
import moment from 'moment'

export default {
  name: 'ContractorPermitLookup',
  props: {
    },
  data() {
    return {
      placeholder: "Search by license holder, company, or #",
      searchInput: null,
      search:"",
      status: 'search',
      ready: false,
      detailReady: false,
      contractorArray: [],
      dropdown: [],
      emptyResponse: null,
      filterTypes: {
        permitTypes: null,
        permitStatus: null,
        contractorNames: null,
      },
      filterData: [],
      key: 0,
      searchOptions: {
        shouldSort: false,
        threshold: 0.2,
        // ISSUEDATE is deliberately not searched: as a raw epoch number fuse always
        // skipped it, and fuzzy-matching against its ISO string would make searches
        // like "2026" match every row
        keys: [
          'PERMITNUMBER',
          'PERMITTYPE',
          'STATUS',
          'CONTRACTORNAME',
        ],
      },
      options: {
        filterable: false,
        perPageValues: [],
        addSortedClassToCells: true,
        pagination: { 
          chunk: 5,
          edge: true,
          // nav: 'scroll',
        },
        headings: { 
          PERMITNUMBER: "Permit number",
          PERMITTYPE: "Permit type",
          STATUS: "Status",
          ISSUEDATE: "Date Issued",
          CONTRACTORNAME: "Contractor",
        },
        cellClasses: {
          PERMITNUMBER: [
            {
              class:'underline has-text-link has-text-weight-semibold',
              condition: () => true,
            }
          ],
          // a date should never wrap mid-value, whatever the column math does
          ISSUEDATE: [
            {
              class:'nowrap',
              condition: () => true,
            }
          ],
        },
      },
      routerQuery: {},
    }
  },
  components: {
    SearchBox,
  },
  beforeCreate(){
    this.$store.commit('updateHeader', 'contractorPermitLookup');
  },
  async created(){
    // console.log(this.$route, this.$store.state)

    if (this.status === 'search' && this.$route.query.searchTerm) {
      // console.log("Created running", this.$route);
      this.searchInput = this.$route.query.searchTerm
      Object.keys(this.$route.query).forEach(
        key => ( key !== 'searchTerm' ? this.filterTypes[key] = this.$route.query[key] : "" )
      )
      try {
        // console.log("route: ", this.$route.query )
        if(typeof this.$route.query.Id  !== 'undefined') {
          // console.log("Route QUERY ID PRESENT")
          await this.getContractorPermits(this.$route.query.Id);
        } else {
          await this.getContractorPermits()
        }
      } catch (err) {
        console.warn("Oops", err);
      } 
    } else {
      this.ready = true
    }
    // this.$store.commit('updateHeader', 'propertyHistory');

  },
  destroyed(){
    this.$store.commit('updateHeader', null);
  },
    watch: {
      filterTypes: {
        handler: function(value) {
          this.updateRouterQuery('filterTypes', value);
        },
        deep: true,
      },
      routerQuery: {
        handler: function () {
          this.updateRouter();
        },
        deep: true,
      },
      '$route.query': function(newVal, oldVal) {
        // console.log("Router watcher: ", newVal)
        if(newVal.Id) {
          this.openDetail(newVal.Id);
        }
      },

  },
  computed: {
    detailPageOpen(){
      return this.$store.state.detailPage
    },
  },
  methods: {
    async openDetail(value) {
      console.log("openDetail(value): ", value );
      // console.log("Each: ", value, this.$store.state.contractorPermitLookup.permitDetails );
      await this.$store.dispatch('contractorPermitLookup/getPermitsDetails', value);
      let record = await this.$store.state.contractorPermitLookup.permitDetails.filter(obj => obj.permitnumber === value)[0];
      console.log("record: ", record)
      await this.getZoningDocs(value);
      await this.$store.dispatch('getPermitAIS', record);
        this.$router.push( {
          name: 'contractorPermitDetail',
          query: { searchTerm: this.searchInput, Id: value },
      }).catch(()=>{});
      this.detailReady = true;
      this.ready = true;
    },
    async getZoningDocs(value){
      let sizeArray = [];
      await this.$store.dispatch('getZoningDocInfo', value).then(
        response => {
          let docIdList = [];
          response.forEach( a => {
            docIdList.push(a.doc_id + ".pdf");
          });

          docIdList.forEach(async a => {
            let sizeObject = new Object()
            // console.log("getting size hopefully from response: ", a, response)
            let eclipse = response.filter(obj => obj.doc_id + ".pdf" === a )[0]["eclipse"];
            let payload = { a: a, eclipse: eclipse }
            sizeObject.name = a;
            sizeObject.size = await this.$store.dispatch('getAWSFileSize', payload)
            sizeArray.push(sizeObject);
          });
          // console.log("Does size Array work?: ", sizeArray);
        }
      );
      return this.$store.commit('setZoningDocFileSizes', sizeArray);
    },
    async getContractorPermits(detail) {
      // console.log("getContractorPermits: ", detail);
      // this.$route.name === 'permit-search-error' ? this.$route.push({ name: Contractor Permit Lookup}) : "";
      this.emptyResponse = null;
      this.status !== 'search' ? this.clearFilters(): "";
      this.status = 'loading';

      try {
        await this.$store.dispatch('contractorPermitLookup/getContractorPermits', this.searchInput);
        // console.log("set status");
        let urlQuery = detail && detail.Id === 'MouseEvent' ? { searchTerm: this.searchInput , Id: detail} : { searchTerm: this.searchInput}
        this.$router.push(
          { name: 'contractorPermitSearch',
            query: urlQuery,
          }).catch(()=>{});
        this.status = 'results';
        this.checkEmptyReponse();
      } catch (err) {
        // console.log("Response errored: ", err);
          this.status = 'error';
      } finally {
        // console.log("emptyResponse: ", this.emptyResponse, detail, typeof detail);
        // this.emptyResponse ? this.clearFilters() : this.filter();
        typeof detail === 'string' | typeof detail === 'number' ? this.openDetail(detail) : (this.ready = true, this.detailReady = false);
      }
    },
    checkEmptyReponse(){
      if (!this.status !== 'error') {
        this.$store.state.contractorPermitLookup.contractorPermits.length < 1 ? this.emptyResponse = this.searchInput : this.emptyResponse = null;
        if (this.emptyResponse) {
          // this.clearFilters();
          this.status = 'error';
          this.$router.push(
            { name: 'permit-search-error',
              query: { address: this.emptyResponse},
              params:  { searchTerm: this.emptyResponse }
            }).catch(()=>{});
        }
        this.filter();
      }
    },

    clearFilters() {
      this.$set(this.filterTypes, 'permitTypes', '');
      this.$set(this.filterTypes, 'permitStatus', '');
      this.key++

    if(this.searchInput !== '' && !this.emptyResponse) {
      this.routerQuery = {
        searchTerm: this.searchInput
      }
    } else {
      // console.log("deleting router ")
      this.searchInput = null;
      this.status ='search';
      this.$delete(this.routerQuery, "searchTerm");
      this.$router.push('/contractor-permit-lookup').catch(()=>{})
    }
    // console.log("filtering after clear filters")
      this.filter()
    },
    setFilter (event, type) {
        // console.log("setFilter: ", event, type, this.filterTypes)
        if (type) {
          if(event.target) {
            this.filterTypes[type] = event.target.value;
          } else {
            this.filterTypes[type] = event;
          }
          if (event.target && event.target.value === '') {
            this.filterTypes[type] = null;
          } else if(event === '') {
            this.filterTypes[type] = null;
          }
        }
        this.filter();
    },
    filterByType(selection) {
      // console.log('ContractorPermitLookup.vue, filterByType is running, selection:', selection, 'this.filterTypes:', this.filterTypes);
      let filters = { PERMITTYPE: this.filterTypes.permitTypes , STATUS: this.filterTypes.permitStatus , CONTRACTORNAME: this.filterTypes.contractorNames }
      var result = selection;
      if(this.filterTypes.permitTypes || this.filterTypes.permitStatus || this.filterTypes.contractorNames) {
        // console.log("selection: ", selection)
        Object.entries(filters).forEach(
          filter => {
            if(filter[1]) {
              result = result.filter(row => {
                return row[filter[0]] == filter[1];
            });
            } 
          }
        )
      } 
      return result
    },
    dateFormat(date){
      // console.log(date, moment(date).isValid(), moment(date));
      if (moment(date).isValid()) {
        return moment(date).format('MMM DD, YYYY')
      }
      return date
    },

    async filter () {
      // console.log('ContractorPermitLookup.vue, filter is running');
      let result= [];
      Object.entries(this.$store.state.contractorPermitLookup.contractorPermits).forEach((a => result.push(a[1])));
      this.filterData = await this.filterByType(result)
    },
    updateRouterQuery: function (key, value) {
      // console.log("updateRouterQuery: ", key, Object.entries(value))
      if(this.searchInput && this.searchInput !== '') {
        this.routerQuery.searchTerm = this.searchInput;
      }

      Object.entries(value).forEach(
           entry => {
             if(entry[1]) {
               this.$set(this.routerQuery, [entry[0]], entry[1])
             } else {
               this.$delete(this.routerQuery, key);
             }
           }
      );
      // console.log("this.routerQuery: ", this.routerQuery)
    },
    // resetRouterQuery: function () {
    //   console.log(this.$route)
    //   for (let routeKey in this.$route.query) {
    //     this.$delete(this.routerQuery, routeKey);
    //   }
    // },

    updateRouter: function () {
      // console.log("updateRouter: ", this.routerQuery, this.$route.query);
      if (this.routerQuery  === this.$route.query) {
        return;
      } 
      if(Object.values(this.routerQuery).length > 0) {
        this.$router.push({
          name: 'contractorPermitSearch',
          query: this.routerQuery,
        }).catch(e => {
          window.console.log(e); 
          return
        });
      } else {
        this.$router.push({
          name: 'contractorPermitLookup',
        }).catch(e => {
          window.console.log(e); 
        });
      }
      // console.log(this.$route)
    },
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 768px) {
  #app > main {
      display: inline;
  }
  .search-bar {
    padding: 15px;
    div>div.is-10, div>div>form {
      margin: 0 15px 0 15px;
    }
  }
}

// @media (min-width: $tablet) {
//   main>div>.contractor-permit-lookup {
//     // padding-left: 45px;
//     // margin-right: -5px;
//   }
// }
div.columns#filters>div.unset-margin {
  margin: unset;
}

td.nowrap {
  white-space: nowrap;
}

</style>
<style lang="scss" scoped>
  // h1 {
  //   margin-bottom: 25px;
  //   line-height: 1.75rem;
  // }

  div.column>.input-wrap {
    padding: 0;
  }
  .detail {
    margin: auto;
  }
  .search-bar-contractor {
    display: flow-root;
    background-color: $ben-franklin-blue-light;
    padding: 25px 35px 25px 35px;
    &.columns {
      margin-top: 0;
      margin-bottom: 0;
    }

    .column {
      padding-top: 5px;
      padding-bottom:5px;
    }
  }
  .search-bar-content {
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    h3 {
      color: #444444;
    }
    p {
    font-size: smaller;
    }
  }

  .red {
    color: #cc3000;
    font-size: 1.5rem;
  }

  .search-error {
    font-weight: bold;
    font-size: 1.25rem;
    margin-left: 45px !important;
  }


  .bottom-grey-header{
    background-color: $ghost-grey;
    bottom: 0;
    position: absolute;
    width: 100%;
    left: 0;
    text-align: center;
    padding: 25px;
    font-size: larger;
  }

  .left {
    float: left;
  }


.clear-filters {
  position: relative;
  top: 50%;
}


</style>
